import script from "./BottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNav.vue?vue&type=script&setup=true&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=89ed3128&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89ed3128"]])

export default __exports__